import UltMeta, { Meta } from "./UltMeta/index";

class OrderType extends UltMeta {
    PURCHASE = new Meta(1, "采购订单");
    DELIVER_APPLY = new Meta(2, "提货申请");
}
export const ORDER_TYPE = new OrderType();

/** pc端订单状态 */
class UserOrderStatus extends UltMeta {
    DRAFT = new Meta(65536, "草稿");
    SIGNING = new Meta(196608, "待签署"); // 双方未签署
    BUYER_SIGNED = new Meta(196609, "签署中"); // 买方签署完成
    SUPPLY_SIGNED = new Meta(196610, "待签署"); // 卖方签署完成
    CONFIRMING = new Meta(262145, "确认中");
    REJECTED = new Meta(131075, "已驳回");
    COMPLETED = new Meta(327683, "已完成");
    INVALIDING = new Meta(458752, "作废中");
    INVALID = new Meta(524288, "已作废");
}
export const USER_ORDER_STATUS = new UserOrderStatus();

/** pc端订单查询状态 */
class UserSearchOrderStatus extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_SIGNED = new Meta(6, "待签署");
    SIGNING = new Meta(3, "签署中");
    CONFIRMING = new Meta(4, "确认中");
    REVERTED = new Meta(2, "已驳回");
    FINISHED = new Meta(5, "已完成");
    INVALIDING = new Meta(7, "作废中");
    INVALID = new Meta(8, "已作废");
}
export const USER_SEARCH_ORDER_STATUS = new UserSearchOrderStatus();

/** 签收状态 */
class ReceiveStatus extends UltMeta {
    NOT_STARTED = new Meta(0, "未签收");
    IN_PROGRESS = new Meta(1, "签收中");
    COMPLETED = new Meta(2, "已签收");
}
export const ORDER_RECEIVE_STATUS = new ReceiveStatus();

/** 结算状态 */
class ReconciliationStatus extends UltMeta {
    NOT_STARTED = new Meta(0, "未结算");
    IN_PROGRESS = new Meta(1, "结算中");
    COMPLETED = new Meta(2, "已结算");
    INVALID = new Meta(3, "作废中");
    PRE_RECONCILIATION = new Meta(4, "预结算");
}
export const ORDER_RECONCILIATION_STATUS = new ReconciliationStatus();

/** 后台订单状态 */
class AdminOrderStatus extends UltMeta {
    DRAFT = new Meta(65536, "草稿");
    SIGNING = new Meta(196608, "待签署"); // 双方未签署
    BUYER_SIGNED = new Meta(196609, "待签署"); // 买方签署完成
    SUPPLY_SIGNED = new Meta(196610, "签署中"); // 卖方签署完成
    CONFIRMING = new Meta(262145, "待确认");
    COMPLETED = new Meta(327683, "已完成");
    INVALIDING = new Meta(458752, "作废中");
    INVALID = new Meta(524288, "已作废");
}
export const ADMIN_ORDER_STATUS = new AdminOrderStatus();

class InvalidButton extends UltMeta {
    INITIATE_CANCELLATION = new Meta(1, "发起作废");
    SIGN_CANCELLATION_DOCUMENT = new Meta(2, "作废签署");
    CONFIRM_CANCELLATION = new Meta(3, "确认作废");
    REJECT_CANCELLATION = new Meta(4, "驳回");
}
export const INVALID_BUTTON = new InvalidButton();

/** 后台订单查询状态 */
class AdminSearchOrderStatus extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_SIGNED = new Meta(6, "待签署");
    SIGNING = new Meta(3, "签署中");
    CONFIRMING = new Meta(4, "待确认");
    FINISHED = new Meta(5, "已完成");
    INVALIDING = new Meta(7, "作废中");
    INVALID = new Meta(8, "已作废");
}
export const ADMIN_SEARCH_ORDER_STATUS = new AdminSearchOrderStatus();

/**
 * 发货状态 deliveryStatus
 */
class DeliveryStatus extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}

export const DELIVERY_STATUS = new DeliveryStatus();

// 订单物流方式
class LogisticsWay extends UltMeta {
    SHIPPING = new Meta(1, "船运");
    CAR = new Meta(2, "汽运");
    TRAIN = new Meta(4, "火车");
    NONE = new Meta(6, "无");
}

export const LOGISTICS_WAY = new LogisticsWay();

// 黄昌龙：后端目前只实现了 发货、订单、签收、对账
class CorrelationTable extends UltMeta {
    CONTRACT = new Meta(1, "采购合同");
    GOODS = new Meta(2, "货物单");
    GOODS_RECEIPT = new Meta(3, "货物签收单");
    INVOICE = new Meta(4, "发票");
    PAYMENT = new Meta(5, "付款单");
    RECONCILIATION = new Meta(6, "结算单");
    ORDER = new Meta(7, "订单");
    STOCKTAKING = new Meta(8, "盘点单", 1);
    OUTBOUND = new Meta(9, "出库单", 1);
    STOCK_CHECK = new Meta(10, "抽检单", 1);
    INBOUND = new Meta(11, "入库单", 1);
    STOCK_CONTRACT = new Meta(12, "仓储业务合同", 2);
    TRANSFER = new Meta(13, "仓储业务过户管理", 2);
    PRE_RECONCILIATION = new Meta(14, "预对账单", 1);
    STORE_CONTRACT = new Meta(15, "仓储管理合同", 3);
    STOCK_STOCKTAKING = new Meta(16, "仓储业务盘点单", 2);
    STOCK_OUTBOUND = new Meta(17, "仓储业务出库单", 2);
    STOCK_STOCK_CHECK = new Meta(18, "仓储业务抽检单", 2);
    STOCK_INBOUND = new Meta(19, "仓储业务入库单", 2);
}
export const CORRELATION_TABLE = new CorrelationTable();

/** 1.4.0 供应链 - 采购订单查询状态 */
// 订单状态：草稿、待发起、待签署、签署中、确认中、已驳回、已完成、作废中、已作废
class AdminPurchaseOrderSearchStatus extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_INITIATED = new Meta(9, "待发起");
    TO_BE_SIGNED = new Meta(6, "待签署");
    SIGNING = new Meta(3, "签署中");
    CONFIRMING = new Meta(4, "确认中");
    REVERTED = new Meta(2, "已驳回");
    FINISHED = new Meta(5, "已完成");
    INVALIDING = new Meta(7, "作废中");
    INVALID = new Meta(8, "已作废");
}
export const ADMIN_PURCHASE_ORDER_SEARCH_STATUS = new AdminPurchaseOrderSearchStatus();

/** 1.4.0供应链-进销存-采购订单状态 */
// ADMIN_ORDER_STATUS  复制过来的 供应链采购订单用这个
class AdminPurchaseOrderStatus extends UltMeta {
    DRAFT = new Meta(65536, "草稿");
    TO_BE_INITIATED = new Meta(589825, "待发起");
    SIGNING = new Meta(196608, "待签署");
    BUYER_SIGNED = new Meta(196609, "签署中"); // 买方签署完成
    SUPPLY_SIGNED = new Meta(196610, "待签署"); // 卖方签署完成
    CONFIRMING = new Meta(262145, "确认中");
    REJECTED = new Meta(131075, "已驳回");
    COMPLETED = new Meta(327683, "已完成");
    INVALIDING = new Meta(458752, "作废中");
    INVALID = new Meta(524288, "已作废");
}
export const ADMIN_PURCHASE_ORDER_STATUS = new AdminPurchaseOrderStatus();

/**
 * 物流方式
 */
class OrderDeliverWay extends UltMeta {
    SHIPPING = new Meta(1, "船运");
    CAR = new Meta(2, "汽运");
    // AIRPLANE = new Meta(3, "航运");
    RAILWAY = new Meta(4, "铁路");
    // SELF_PICKUP = new Meta(5, "自提");
    NONE = new Meta(6, "无");
}

export const ORDER_DELIVER_WAY = new OrderDeliverWay();

/**
 * 1.4.0 客户端-销售管理-订单
 *
 * 订单状态  复制的ADMIN_ORDER_STATUS- 待定未联调
 */

/** pc端销售订单查询状态 */
class UserSearchOrderSalesStatus extends UltMeta {
    SIGNING = new Meta(3, "签署中");
    TO_BE_SIGNED = new Meta(6, "待签署");
    CONFIRMING = new Meta(4, "待确认"); // 待定
    FINISHED = new Meta(5, "已完成");
    INVALIDING = new Meta(7, "作废中");
    INVALID = new Meta(8, "已作废");
}
export const USER_SEARCH_ORDER_SALES_STATUS = new UserSearchOrderSalesStatus();

class OrderSaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
    COMMIT_AND_GOODS = new Meta(3, "提交并生成提货单");
    COMMIT_AND_GOODS_RECEIPT = new Meta(4, "提交并生成提货单和签收单");
    COMMIT_AND_GOODS_RECEIPT_SETTLEMENT = new Meta(5, "提交并生成提货单、签收单和结算单");
}

export const ORDER_SAVE_TYPE = new OrderSaveType();
